import { useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/modules/shared/ui/components/dialog"
import { Button } from "@/modules/shared/ui/components/button"

interface FlagSectionDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onFlag: (note: string) => Promise<void>
  sectionName: string
}

export function FlagSectionDialog({
  open,
  onOpenChange,
  onFlag,
  sectionName,
}: FlagSectionDialogProps) {
  const [note, setNote] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleFlag = async () => {
    if (!note.trim()) return

    setIsSubmitting(true)
    try {
      await onFlag(note)
      setNote("")
      onOpenChange(false)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reject Section: {sectionName}</DialogTitle>
          <DialogDescription>
            Provide a note explaining what needs to be corrected in this
            section. The employee will see this note and be able to resubmit.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-foreground">Note</label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              className="mt-1 w-full rounded-md border border-border p-2 text-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
              rows={4}
              placeholder="Explain what needs to be corrected in this section..."
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleFlag}
            disabled={isSubmitting || !note.trim()}
            className="bg-orange-500 hover:bg-orange-600"
          >
            {isSubmitting ? "Rejecting..." : "Reject Section"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
